import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NexusComponent } from 'app/core/components/nexus/nexus.component';
import { EmailModel } from 'app/core/models/email.model';
import { UnsubscribeModel } from 'app/core/models/unsubscribe.model';
import { MembershipService } from 'app/core/services/membership.service';

@Component({
    selector: 'app-unsubscribe',
    templateUrl: './unsubscribe.component.html',
    styleUrls: ['./unsubscribe.component.scss'],
    standalone: false
})
export class UnsubscribeComponent extends NexusComponent implements OnInit {
  public unsubscribe_model: UnsubscribeModel = new UnsubscribeModel();

  constructor(public membership: MembershipService, private router: Router, private route: ActivatedRoute) {
    super();
  }

  ngOnInit() {
  this.route.data.subscribe(params => {
            this.unsubscribe_model = params.email_model;
        });
  }

  resubscribe(event: Event)
  {
    event.preventDefault();
    this.StartSpinner();

        this.membership.ResubscribeEmail(this.unsubscribe_model.email_id, this.unsubscribe_model).subscribe(
            data => {
                this.StopSpinner();
                this.unsubscribe_model = data;
            },
            err => {
                this.StopSpinner();
            });
  }

  unsubscribe(event: Event)
  {
    event.preventDefault();
    this.StartSpinner();

        this.membership.UnsubscribeEmail(this.unsubscribe_model.email_id, this.unsubscribe_model).subscribe(
            data => {
                this.StopSpinner();
                this.unsubscribe_model = data;
            },
            err => {
                this.StopSpinner();
            });
  }
}
